export default __webpack_public_path__ + "static/media/showroom45.398bccb2.jpg";